import axios from "axios";
import { environment } from "@environments/environment";

export async function getExamSessionsByAdmin() {
  const token = localStorage.getItem("accessToken");
  const userDto = JSON.parse(localStorage.getItem("userDto") || "{}");
  const apiInstance = axios.create({
    baseURL: environment?.apiURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    const response = await apiInstance.get(
      `api/v1/exam-sessions/created-by/${userDto?.userId}`
    );
    if (response?.data) {
      return response?.data || {};
    } else {
      throw new Error("Failed to fetch data from the API");
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error(
      "Error fetching data: " +
        (error instanceof Error ? error.message : String(error))
    );
  }
}

export async function getExamSessionDetailsById(examId: string) {
  const token = localStorage.getItem("accessToken");
  const apiInstance = axios.create({
    baseURL: environment?.apiURL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  try {
    const response = await apiInstance.get(`api/v1/exam-sessions/${examId}`);
    if (response?.data) {
      return response?.data || {};
    } else {
      throw new Error("Failed to fetch data from the API");
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error(
      "Error fetching data: " +
        (error instanceof Error ? error.message : String(error))
    );
  }
}
